import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { BagDetails, type BagInfo } from "@/components/BagDetails";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Helmet } from "react-helmet";

const formatBagData = (bagData: any): BagInfo => {
  return {
    id: bagData.id,
    styleNumber: bagData.style_number?.toString().padStart(4, '0') || "",
    alternateStyleNumber: bagData.alternate_style_number?.toString() || undefined,
    name: bagData.Name || "",
    description: bagData.description || "",
    measurements: {
      height: bagData.Height || "Not specified",
      width: bagData.Width || "Not specified",
      depth: bagData.Depth || "Not specified",
      strap: bagData.Strap || undefined,
      alternate: bagData.Alternate_Measurements || undefined
    },
    years: bagData.Years_in_Production || "Unknown",
    alternativeName: bagData.alternate_name || undefined,
    colors: bagData.Colors || undefined,
    mainImage: bagData.main_image || undefined,
    catalogPages: []
  };
};

const Index = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [bagInfo, setBagInfo] = useState<BagInfo | null>(null);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleSearch = async (uuid: string) => {
    setIsLoading(true);
    setBagInfo(null);

    try {
      const { data: match, error } = await supabase
        .from('coach_bag_real_data')
        .select('*')
        .eq('id', uuid)
        .maybeSingle();

      if (error) throw error;

      if (match) {
        setBagInfo(formatBagData(match));
      } else {
        toast({
          title: "Style Not Found",
          description: "We couldn't find a bag with that ID. Please try another.",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error('Error searching for bag:', error);
      toast({
        title: "Error",
        description: "Something went wrong while searching. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Vintage Coach Bag Database - Search & Identify Your Coach Bag</title>
        <meta name="description" content="Search our comprehensive database of vintage Coach bags by style number or name. Find detailed measurements, production years, and authenticity features for your Coach bag." />
      </Helmet>
      <div className="min-h-screen flex flex-col bg-background">
        <div className="flex-grow flex items-center justify-center">
          <div className="w-full">
            <Header showAboutLink={true} />
            {bagInfo && <BagDetails bag={bagInfo} isLoading={isLoading} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
